module.exports = __webpack_public_path__ + "img/terminate-service.906fd963.png";